import React, { useState } from "react"
import { Link } from "gatsby"
import classnames from "classnames"
import ChevronRightIcon from "../../content/assets/svg/chevron-right.svg"

const SidebarNavigation = ({
  pages,
  currentPageId,
  title,
  alwaysOpen,
  languageCode,
}) => {
  const [open, setOpen] = useState(
    pages
      ? pages.some(item =>
          languageCode === "es"
            ? item.page.translations[0].id === currentPageId
            : item.page.id === currentPageId
        )
      : false
  )

  return (
    <nav className={`sidebar-navigation ${alwaysOpen ? "always-open" : ""}`}>
      <h4 className="sidebar-title">
        {alwaysOpen ? (
          title
        ) : (
          <button
            className={classnames("sidebar-toggle", {
              open,
            })}
            onClick={() => setOpen(!open)}
          >
            {title}
            <ChevronRightIcon />
          </button>
        )}
      </h4>
      {(alwaysOpen || open) && (
        <ul className="navigation-items">
          {pages.map((item, index) => {
            const title =
                languageCode === "es"
                  ? item.page.translations[0].title
                  : item.page.title,
              url =
                languageCode === "es"
                  ? item.page.translations[0].uri
                  : item.page.uri

            return (
              <li key={index}>
                <Link
                  to={url}
                  className={classnames("navigation-link", {
                    current:
                      languageCode === "es"
                        ? item.page.translations[0].id === currentPageId
                        : item.page.id === currentPageId,
                  })}
                >
                  {languageCode === "es"
                    ? item.page.translations[0].customFields.navigationTitle
                    : item.page.customFields.navigationTitle || title}
                </Link>
              </li>
            )
          })}
        </ul>
      )}
    </nav>
  )
}

export default SidebarNavigation
